export enum MilestoneLogType {
    Created = 'created',
    EnergyOrdered = 'energy-ordered',
}
